export const hasLoggedAGenericUser = () => {
  return getUserProfileType() === "standard";
};

export const hasLoggedAnOperatorUser = () => {
  return getUserProfileType() === "operator";
};

export const getUserProfileType = () => {
  // TODO: aprire il jwtToken e determinare i claims
  return "standard";
};
